
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serii-knig/[pageNumber]",
      function () {
        return require("private-next-pages/serii-knig/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serii-knig/[pageNumber]"])
      });
    }
  